import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import {RouterSelfInstallSteps, NiudSteps} from './Assets/variables';
import {showAppLoader, hideAppLoader} from '../../Shared/Loader/LoaderSlice';
import ProviderManager from '../../../provider/providerManager';

export const initiateWizard = createAsyncThunk('routerSelfInstall/initiateWizard', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());
    const result = await ProviderManager.getProviderData('InitiateFiberMigrationWizard', data);
    thunkAPI.dispatch(hideAppLoader());
    return {data: result.Body, serverError: false};
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());

    return {serverError: true};
  }
});

export const getWizardStep = createAsyncThunk('routerSelfInstall/getWizardStep', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('getFiberMigrationWizardStep', data);
    return {data: result.Body, serverError: false};
  } catch (error) {
    return {serverError: true};
  }
});

const initialState = {
  step: RouterSelfInstallSteps.INTRO,
  niudStep: NiudSteps.NIUD,
  shouldUpdateStep: false,
  stepUpdateTo: '',
  error: {
    niudError: false,
    reservationError: false,
    configError: false,
    radiusError: false,
    errorNum: '',
  },
};

const routerSelfInstallSlice = createSlice({
  name: 'routerSelfInstall',
  initialState: initialState,
  reducers: {
    resetState: (state) => initialState,
    setStep: (state, action) => {
      state.step = action.payload;
      state.shouldUpdateStep = false;
      state.stepUpdateTo = '';
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
  extraReducers: {
    [getWizardStep.pending]: (state, action) => {
      return state;
    },
    [getWizardStep.fulfilled]: (state, action) => {
      if (action.payload.serverError) {
        state.error.isError = true;
        state.step = RouterSelfInstallSteps.ERROR;
        return state;
      }
      state.error.errorCode = action.payload.data.outputCode1;
      switch (action.payload.data.outputCode1) {
        case '435.001':
        case '435.002':
          state.error.reservationError = true;
          state.error.isError = true;
          state.error.errorNum = action.payload.data.outputCode1;
          state.step = RouterSelfInstallSteps.ERROR;
          return state;
        case '435.199':
        case '435.005':
        case '435.003':
        case '435.299':
          state.error.niudError = true;
          state.error.isError = true;
          state.step = RouterSelfInstallSteps.ERROR;
          state.error.errorNum = action.payload.data.outputCode1;
          return state;
        case '435.009':
        case '435.007':
        case '435.399':
        case '435.499':
          state.error.isError = true;
          state.error.configError = true;
          state.error.errorNum = action.payload.data.outputCode1;

          if (state.niudStep == NiudSteps.NIUD) {
            state.shouldUpdateStep = true;
            if (action.payload.data.outputCode1 == '435.399' || action.payload.data.outputCode1 == '435.007') {
              state.niudStep = NiudSteps.UPDATESETTINGS;
            } else {
              state.niudStep = NiudSteps.CONFIGURING;
            }
          } else {
            state.step = RouterSelfInstallSteps.ERROR;
          }
          return state;
        case '435.011':
          state.error.isError = true;
          state.error.radiusError = true;
          state.error.errorNum = action.payload.data.outputCode1;

          if (state.niudStep != NiudSteps.ALMOSTFINISH) {
            state.shouldUpdateStep = true;
            state.niudStep = NiudSteps.ALMOSTFINISH;
          } else {
            state.step = RouterSelfInstallSteps.ERROR;
          }
          return state;
        case '435.000':
          state.step = RouterSelfInstallSteps.SUCCESS;
          return state;
        case '435.012':
          if (state.niudStep != NiudSteps.ALMOSTFINISH) {
            state.shouldUpdateStep = true;
            state.stepUpdateTo = RouterSelfInstallSteps.SELFCHECK;
            state.niudStep = NiudSteps.ALMOSTFINISH;
          } else {
            state.step = RouterSelfInstallSteps.SELFCHECK;
          }
          return state;
        case '435.006':
          state.niudStep = NiudSteps.UPDATESETTINGS;
          return state;
        case '435.008':
          state.niudStep = NiudSteps.CONFIGURING;
          return state;
        case '435.010':
          state.niudStep = NiudSteps.ALMOSTFINISH;
          return state;
        default:
          /*state.error.isError = true;
          state.step = RouterSelfInstallSteps.ERROR;*/
          return state;
      }
    },
    [getWizardStep.rejected]: (state, action) => {
      state.error.isError = true;
      state.error.reservationError = true;
      state.step = RouterSelfInstallSteps.ERROR;
      return state;
    },
    [initiateWizard.pending]: (state, action) => {
      return state;
    },
    [initiateWizard.fulfilled]: (state, action) => {
      if (action.payload.serverError) {
        state.error.isError = true;
        state.step = RouterSelfInstallSteps.ERROR;
        return state;
      }
      state.step = RouterSelfInstallSteps.LOADING;
      return state;
    },
    [initiateWizard.rejected]: (state, action) => {
      state.error.isError = true;
      state.error.niudError = true;
      state.step = RouterSelfInstallSteps.ERROR;
      return state;
    },
  },
});

export const {resetState, setStep, setError} = routerSelfInstallSlice.actions;

export default routerSelfInstallSlice.reducer;
